module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('HeadersDetalhesResumo', {
    attrs: {
      "apelido": _vm.imovel.apelido,
      "proprietario": _vm.imovel.proprietario,
      "tipo": _vm.imovel.tipo,
      "savoynet": _vm.imovel.savoynet
    }
  }), _vm._v(" "), _c('v-layout', {
    staticClass: "secondary white--text detalhes-header",
    attrs: {
      "row": "",
      "wrap": "",
      "align-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs2": ""
    }
  }, [_c('v-container', {
    staticClass: "py-2",
    attrs: {
      "fluid": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "text-xs-left",
    attrs: {
      "xs12": ""
    }
  }, [_c('v-btn', {
    staticClass: "ma-0 white--text",
    attrs: {
      "icon": "",
      "to": ({
        name: 'ImoveisDetalhesResumo',
        params: {
          id: _vm.$route.params.id
        }
      })
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs8": ""
    }
  }, [_c('v-container', {
    staticClass: "py-2",
    attrs: {
      "fluid": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('span', {
    staticClass: "subtitulo"
  }, [_vm._v("IPTU / impostos / taxas")])])], 1)], 1)], 1)], 1), _vm._v(" "), (_vm.taxas.length > 0) ? _vm._l((_vm.taxas), function(item, index) {
    return _c('v-card', {
      key: item.id,
      attrs: {
        "flat": ""
      }
    }, [_c('v-layout', {
      staticClass: "pt-2",
      attrs: {
        "row": "",
        "wrap": ""
      }
    }, [_c('v-flex', {
      attrs: {
        "xs12": "",
        "sm10": "",
        "offset-sm1": "",
        "md8": "",
        "offset-md2": ""
      }
    }, [_c('v-card-text', [_c('div', {
      staticClass: "mb-1"
    }, [_c('strong', [_vm._v(_vm._s(item.taxa) + ":")]), _vm._v(" " + _vm._s(item.numero))]), _vm._v(" "), (item.situacao) ? _c('div', {
      staticClass: "mb-1"
    }, [_c('strong', [_vm._v("Situação:")]), _vm._v(" " + _vm._s(item.situacao))]) : _vm._e(), _vm._v(" "), (item.situacao === 'Pendente ajuizado' && item.ajuizado_cliente) ? _c('div', {
      staticClass: "mb-1"
    }, [_c('strong', [_vm._v("Cliente/caso:")]), _vm._v(" " + _vm._s(item.ajuizado_cliente))]) : _vm._e(), _vm._v(" "), (item.situacao === 'Pendente ajuizado' && item.ajuizado_processo) ? _c('div', {
      staticClass: "mb-1"
    }, [_c('strong', [_vm._v("Processo/execução:")]), _vm._v(" " + _vm._s(item.ajuizado_processo))]) : _vm._e()]), _vm._v(" "), _c('v-card-actions', {
      staticClass: "text-xs-right"
    }, [(_vm.$hasGranularPermission('taxas', 'edit')) ? _c('v-dialog', {
      attrs: {
        "persistent": "",
        "lazy": "",
        "max-width": "760"
      },
      model: {
        value: (_vm.dialogEditar),
        callback: function($$v) {
          _vm.dialogEditar = $$v
        },
        expression: "dialogEditar"
      }
    }, [_c('v-btn', {
      staticClass: "text-xs-right primary--text",
      attrs: {
        "slot": "activator",
        "flat": ""
      },
      nativeOn: {
        "click": function($event) {
          _vm.beforeEditar(item)
        }
      },
      slot: "activator"
    }, [_vm._v("Editar")]), _vm._v(" "), _c('v-card', [_c('v-card-title', [_c('div', {
      staticClass: "title"
    }, [_vm._v(_vm._s(item.taxa))])]), _vm._v(" "), _c('v-card-text', [_c('v-text-field', {
      directives: [{
        name: "validate",
        rawName: "v-validate",
        value: ('required'),
        expression: "'required'"
      }],
      attrs: {
        "label": "Número da taxa/imposto",
        "name": "adicionar.numero",
        "data-vv-as": "número",
        "error-messages": _vm.errors.has('adicionar.numero') ? _vm.errors.first('adicionar.numero') : []
      },
      model: {
        value: (_vm.formEditar.fields.numero),
        callback: function($$v) {
          _vm.formEditar.fields.numero = $$v
        },
        expression: "formEditar.fields.numero"
      }
    }), _vm._v(" "), _c('v-select', {
      attrs: {
        "auto": "",
        "items": _vm.taxaSituacao,
        "label": "Situação"
      },
      model: {
        value: (_vm.formEditar.fields.situacao),
        callback: function($$v) {
          _vm.formEditar.fields.situacao = $$v
        },
        expression: "formEditar.fields.situacao"
      }
    }), _vm._v(" "), _c('transition', {
      attrs: {
        "name": "slide-x-transition"
      }
    }, [(_vm.formEditar.fields.situacao === 'Pendente ajuizado') ? _c('div', {
      staticStyle: {
        "width": "100%"
      }
    }, [_c('v-text-field', {
      attrs: {
        "label": "Nº do cliente/caso"
      },
      model: {
        value: (_vm.formEditar.fields.ajuizado_cliente),
        callback: function($$v) {
          _vm.formEditar.fields.ajuizado_cliente = $$v
        },
        expression: "formEditar.fields.ajuizado_cliente"
      }
    }), _vm._v(" "), _c('v-text-field', {
      attrs: {
        "label": "Nº do processo/execução"
      },
      model: {
        value: (_vm.formEditar.fields.ajuizado_processo),
        callback: function($$v) {
          _vm.formEditar.fields.ajuizado_processo = $$v
        },
        expression: "formEditar.fields.ajuizado_processo"
      }
    })], 1) : _vm._e()])], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
      staticClass: "error--text",
      attrs: {
        "flat": ""
      },
      nativeOn: {
        "click": function($event) {
          _vm.descartar($event)
        }
      }
    }, [_vm._v("Descartar")]), _vm._v(" "), _c('v-btn', {
      staticClass: "secondary--text",
      attrs: {
        "flat": ""
      },
      nativeOn: {
        "click": function($event) {
          _vm.onSubmitEditar()
        }
      }
    }, [_vm._v("Salvar")])], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.$hasGranularPermission('taxas', 'delete')) ? _c('v-dialog', {
      attrs: {
        "lazy": "",
        "max-width": "520"
      },
      model: {
        value: (_vm.dialogApagar),
        callback: function($$v) {
          _vm.dialogApagar = $$v
        },
        expression: "dialogApagar"
      }
    }, [_c('v-btn', {
      staticClass: "error--text",
      attrs: {
        "slot": "activator",
        "flat": ""
      },
      nativeOn: {
        "click": function($event) {
          _vm.beforeApagar(item)
        }
      },
      slot: "activator"
    }, [_vm._v("Apagar")]), _vm._v(" "), _c('v-card', [_c('v-card-title', [_c('div', {
      staticClass: "headline"
    }, [_vm._v("Tem certeza que deseja apagar?")])]), _vm._v(" "), _c('v-card-text', [_vm._v("Essa ação não poderá ser desfeita.")]), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
      staticClass: "secondary--text",
      attrs: {
        "flat": ""
      },
      nativeOn: {
        "click": function($event) {
          _vm.dialogApagar = false
        }
      }
    }, [_vm._v("Descartar")]), _vm._v(" "), _c('v-btn', {
      staticClass: "error--text",
      attrs: {
        "flat": ""
      },
      nativeOn: {
        "click": function($event) {
          _vm.onSubmitApagar()
        }
      }
    }, [_vm._v("Apagar")])], 1)], 1)], 1) : _vm._e()], 1)], 1)], 1), _vm._v(" "), _c('v-divider')], 1)
  }) : _c('p', {
    staticClass: "text-xs-center mt-5 subheading"
  }, [_vm._v("Nenhuma taxa cadastrada.")]), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "persistent": "",
      "lazy": "",
      "max-width": "760"
    },
    model: {
      value: (_vm.dialog),
      callback: function($$v) {
        _vm.dialog = $$v
      },
      expression: "dialog"
    }
  }, [(_vm.$hasGranularPermission('taxas', 'add')) ? _c('v-btn', {
    staticClass: "secondary",
    attrs: {
      "slot": "activator",
      "dark": "",
      "fab": "",
      "fixed": "",
      "bottom": "",
      "right": ""
    },
    slot: "activator"
  }, [_c('v-icon', [_vm._v("add")])], 1) : _vm._e(), _vm._v(" "), _c('v-card', [_c('v-card-text', [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('v-radio', {
    attrs: {
      "label": "IPTU",
      "value": "IPTU"
    },
    model: {
      value: (_vm.form.fields.selecionarTaxa),
      callback: function($$v) {
        _vm.form.fields.selecionarTaxa = $$v
      },
      expression: "form.fields.selecionarTaxa"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('v-radio', {
    attrs: {
      "label": "Outra taxa",
      "value": "Outra taxa"
    },
    model: {
      value: (_vm.form.fields.selecionarTaxa),
      callback: function($$v) {
        _vm.form.fields.selecionarTaxa = $$v
      },
      expression: "form.fields.selecionarTaxa"
    }
  })], 1)], 1), _vm._v(" "), (_vm.form.fields.selecionarTaxa !== 'IPTU') ? _c('v-text-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "label": "Nome da taxa/imposto",
      "name": "adicionar.taxa",
      "data-vv-as": "taxa",
      "error-messages": _vm.errors.has('adicionar.taxa') ? _vm.errors.first('adicionar.taxa') : []
    },
    model: {
      value: (_vm.form.fields.taxa),
      callback: function($$v) {
        _vm.form.fields.taxa = $$v
      },
      expression: "form.fields.taxa"
    }
  }) : _vm._e(), _vm._v(" "), _c('v-text-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "label": "Número da taxa/imposto",
      "name": "adicionar.numero",
      "data-vv-as": "número",
      "error-messages": _vm.errors.has('adicionar.numero') ? _vm.errors.first('adicionar.numero') : []
    },
    model: {
      value: (_vm.form.fields.numero),
      callback: function($$v) {
        _vm.form.fields.numero = $$v
      },
      expression: "form.fields.numero"
    }
  }), _vm._v(" "), _c('v-select', {
    attrs: {
      "auto": "",
      "items": _vm.taxaSituacao,
      "label": "Situação"
    },
    model: {
      value: (_vm.form.fields.situacao),
      callback: function($$v) {
        _vm.form.fields.situacao = $$v
      },
      expression: "form.fields.situacao"
    }
  }), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "slide-x-transition"
    }
  }, [(_vm.form.fields.situacao === 'Pendente ajuizado') ? _c('div', {
    staticStyle: {
      "width": "100%"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Nº do cliente/caso"
    },
    model: {
      value: (_vm.form.fields.ajuizado_cliente),
      callback: function($$v) {
        _vm.form.fields.ajuizado_cliente = $$v
      },
      expression: "form.fields.ajuizado_cliente"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Nº do processo/execução"
    },
    model: {
      value: (_vm.form.fields.ajuizado_processo),
      callback: function($$v) {
        _vm.form.fields.ajuizado_processo = $$v
      },
      expression: "form.fields.ajuizado_processo"
    }
  })], 1) : _vm._e()])], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "error--text",
    attrs: {
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.descartar($event)
      }
    }
  }, [_vm._v("Descartar")]), _vm._v(" "), _c('v-btn', {
    staticClass: "secondary--text",
    attrs: {
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.onSubmit($event)
      }
    }
  }, [_vm._v("Salvar")])], 1)], 1)], 1), _vm._v(" "), _c('ButtonsObservacoesAnexos', {
    staticClass: "mt-3"
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b5411294"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Imoveis/Detalhes/DetalhesTaxas.vue
// module id = 1040
// module chunks = 1